export default {"src":"/_next/static/media/instagram_icon_white.5e358ba4.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};